import React, { Component } from "react";

//components
import CustomDropdown from "../../../../../generic_components/components/dropdowns/CustomDropdown";
import TextBox from "../../../../../generic_components/components/input_boxes/TextBox";
import CustomCheckBox from "../../../../../generic_components/components/check_boxes/CustomCheckBox";
import AutoCompleteTextBox from "../../../../../generic_components/components/input_boxes/AutoCompleteTextBox";
import LoadingPgTemplate from "../../../../../generic_components/view/LoadingPgTemplate";
import CariAppFormNavBtnBar from "../../../components/cari_app_form_components/CariAppFormNavBtnBar";
import CariMainPgFooterView from "../../cari_template_view/CariMainPgFooterView";
import CustomButton from "../../../../../generic_components/components/buttons/CustomButton";

//generic functions
import {
    isEmpty
} from "../../../../../functions/generic_functions";

import { 
    cari_app_form_pg_1_url, 
    cari_app_form_pg_2_url, 
    cari_app_form_pg_3_url, 
    cari_app_form_pg_4_url, 
} from "../../../../../router/static_routes";

import { connect } from "react-redux";

//router
import {
    withRouter,
} from 'react-router-dom';

import {
    openCariModal,
    resetCariActiveData,
    setCariActiveUserData
} from "../../../../../redux/actions/indexActions";

//redux mapper
const mapStateToProps = state => {
    return {
        activeApplicationData: state.cariReducer.activeApplicationData,
        activeVerifiedLoginUserData: state.cariReducer.activeVerifiedLoginUserData
    };
};

const mapDispatchToProps = dispatch => {

    return {
        openCariModal: (modal_data) => {
            dispatch(openCariModal(modal_data))
        },
        resetCariActiveData: () => {
            dispatch(resetCariActiveData())
        },
        setCariActiveUserData: (user_data) => {
            dispatch(setCariActiveUserData(user_data))
        },
    };
};

/*
    props:
        autoCompleteUrls {
            cari_api_university_auto_complete_url => url of university auto complete
            cari_api_country_auto_complete_url => url of country auto complete
        }
        autoCompleteParams {
            //auto complete parameters
        }

        pageLoaded => conditional rendering upon api load
        onChangeSetParentState => function to set parent state
        postData => postData json, all post data for this page
        staticUiData => staticUiData json, all static loaded ui data for dropdowns, radio btns, etc
        submitted => true/false, sets the entire page to be disabled
                hideFailedAppCreateModal => the function to hide the modal of failed app creation
            
*/

class CariAppFormViewPg2 extends Component {
    constructor(Props) {
        super(Props);

        //refs
        this.toastRef = React.createRef();

        //helper functions
        this.getCariFormPgNum = this.getCariFormPageNum.bind(this);

        //handler for add applicant new insitution
        this.handleAddInstitution = this.handleAddInstitution.bind(this);
    }

    getCariFormPageNum() {
        var currentUrl = window.location.pathname;
        var current_cari_pg = null;
        //check which url it corresponds to
        if (currentUrl === cari_app_form_pg_1_url) {
            current_cari_pg = 1;
        }
        else if (currentUrl === cari_app_form_pg_2_url) {
            current_cari_pg = 2;
        }
        else if (currentUrl === cari_app_form_pg_3_url) {
            current_cari_pg = 3;
        }
        else if (currentUrl === cari_app_form_pg_4_url) {
            current_cari_pg = 4;
        }
        else {
            return undefined;
        }
        return current_cari_pg;
    }

    handleAddInstitution(value, nameKey){
        var nameKeyArr = nameKey.split("?");
        var refIndex = nameKeyArr[1]; //ref index

        var copyPostData = this.props.postData;

        var customInstitutionObj = this.props.postData.customInstitutionObj;

        this.props.openCariModal({
            modalId: "addInstitutionModal",
            title: "Add Institution",
            contentText: "Please complete the following fields to add an institution.",
            customInstitutionData: customInstitutionObj,
            callBackFuncOnOk: (data) => {
                var newCustomInstitutionData = data;

                //api call to add new applicant institution, and it will do refresh of page
                if (!isEmpty(this.props.onAddInstitution)) {
                    this.props.onAddInstitution(newCustomInstitutionData, copyPostData[refIndex], refIndex, (institutionAdded, parentCallBackFunc) => {
                        // //only set if mounted
                        if (institutionAdded) {
                            this.toastRef.current.show({ life: 6000, severity: 'success', summary: "Successfully saved the new institution!", detail: "" });

                            //call back to refresh page
                            parentCallBackFunc();
                           
                        }
                        else {
                            //display toast
                            this.toastRef.current.show({ life: 6000, severity: 'error', summary: 'Failed to save the new institution!', detail: "" });
                        }    
                    });
                }
               
            }
        });
    }


    render() {
        return (
            <div className="scene_element scene_element--fadeinright">
                {(!this.props.pageLoaded) ?
                    <LoadingPgTemplate />
                : null}

                <div className={(this.props.pageLoaded) ? "" : "display_none"}>
                    <br />

                    <div className="p-grid">
                        <div className="p-col-12 full-height">

                            <p className="cari_small_text">
                                Please submit the names, institution, relationship, and email addresses of {(this.props.postData.length)} reference(s).<strong className="sfu_red">*</strong>
                                <br />
                                <br />
                                Upon submission of your application, an email will be automatically generated and sent to your references. You may not use your own email address or submit reference letters on anyone’s behalf.
                                <br />
                                <br />
                                If you have any questions regarding submitting your references, please contact the Appointments Secretary at <a href='mailto:bsb_appointments@sfu.ca' target='_blank'>bsb_appointments@sfu.ca<i className="pi pi-envelope"></i></a>.
                            </p>

                            <br />

                            <div>

                                {(this.props.postData !== undefined && this.props.postData.length > 0) ?
                                    this.props.postData.map(function (data, i) {
                                        return (
                                            <div key={i}>
                                                {i != 0 ? <div><br/><br/></div> : null}
                                                <label className="cari_section_title_format">
                                                    Reference {(i + 1)}
                                                </label>

                                                <div className="">
                                                    <br/><br/>

                                                    <div className="p-grid">
                                                        <div className="p-col-6 padding-right_style_col">
                                                            <label className={"label_style"}>
                                                                Salutation/Title <strong className="sfu_red">*</strong>
                                                            </label>
                                                        </div>
                                                        <div className="p-col-6 padding-left_style_col">
                                                            <label className={"label_style"}>
                                                                First Name <strong className="sfu_red">*</strong>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div className="p-grid">
                                                        <div className="p-col-6 padding-right_style_col">
                                                            <CustomDropdown
                                                                value={data['salutation']}
                                                                options={this.props.staticUiData.salutationDropdownOptions}
                                                                placeholder={"Select Salutation"}
                                                                name={"salutation" + "?" + i}
                                                                onChangeSetParentState={this.props.onChangeSetParentState}
                                                                required={true}
                                                                disabled={(this.props.submitted || data['readOnly'])}
                                                            />
                                                        </div>

                                                        <div className="p-col-6 padding-left_style_col">
                                                            <TextBox
                                                                value={data['first_name']}
                                                                name={"first_name" + "?" + i}
                                                                placeholder={((this.props.submitted || data['readOnly']) && data['first_name'] == "")?"":"First Name"}
                                                                onChangeSetParentState={this.props.onChangeSetParentState}
                                                                required={true}
                                                                maxLength={64}
                                                                disabled={(this.props.submitted || data['readOnly'])}
                                                                className={(this.props.submitted || data['readOnly'])? "disabled_input_box_format":"float_right_input_box_format"}
                                                            />
                                                        </div>
                                                    </div>

                                                    <br/>

                                                    <div className="p-grid">
                                                        <div className="p-col-6 padding-right_style_col">
                                                            <label className={"label_style"}>
                                                                Last Name <strong className="sfu_red">*</strong>
                                                            </label>
                                                        </div>
                                                        <div className="p-col-6 padding-left_style_col">
                                                            <label className={"label_style"}>
                                                                Relationship to Applicant <strong className="sfu_red">*</strong>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div className="p-grid">
                                                        <div className="p-col-6 padding-right_style_col">
                                                            <TextBox
                                                                value={data['last_name']}
                                                                name={"last_name" + "?" + i}
                                                                placeholder={((this.props.submitted || data['readOnly']) && data['last_name'] == "")?"":"Last Name"}
                                                                onChangeSetParentState={this.props.onChangeSetParentState}
                                                                required={true}
                                                                maxLength={64}
                                                                disabled={(this.props.submitted || data['readOnly'])}
                                                                className={(this.props.submitted || data['readOnly'])? "disabled_input_box_format":"input_box_format"}
                                                            />
                                                        </div>
                                                        <div className="p-col-6 padding-left_style_col">
                                                            <TextBox
                                                                value={data['relationship']}
                                                                name={"relationship" + "?" + i}
                                                                placeholder={((this.props.submitted || data['readOnly']) && data['relationship'] == "")?"":"Relationship to Applicant"}
                                                                onChangeSetParentState={this.props.onChangeSetParentState}
                                                                required={true}
                                                                maxLength={100}
                                                                disabled={(this.props.submitted || data['readOnly'])}
                                                                className={(this.props.submitted || data['readOnly'])? "disabled_input_box_format":"float_right_input_box_format"}
                                                            />
                                                        </div>
                                                    </div>

                                                    <br/>

                                                    <div className="p-grid">
                                                        <div className="p-col-6 padding-right_style_col">
                                                            <label className={"label_style"}>
                                                                Email Address <strong className="sfu_red">*</strong>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div className="p-grid">   
                                                        <div className="p-col-6 padding-right_style_col">
                                                            <TextBox
                                                                inputType={"email"}
                                                                value={data['email']}
                                                                name={"email" + "?" + i}
                                                                placeholder={((this.props.submitted || data['readOnly']) && data['email'] == "")?"":"Email"}
                                                                onChangeSetParentState={this.props.onChangeSetParentState}
                                                                required={true}
                                                                maxLength={100}
                                                                disabled={(this.props.submitted || data['readOnly'])}
                                                                className={(this.props.submitted || data['readOnly'])? "disabled_input_box_format":"input_box_format"}
                                                            />
                                                        </div>
                                                    </div>

                                                    <br/>

                                                    <div className={(!data['customInstitutionCheckboxVal']) ? "" : "display_none"}>
                                                        <div className="p-grid">
                                                            <div className="p-col-6 padding-right_style_col">
                                                                <label className={"label_style"}>
                                                                    Institution <strong className="sfu_red">*</strong>
                                                                </label>
                                                            </div>
                                                        </div>

                                                        <div className="p-grid">    
                                                            <div className="p-col-6 padding-right_style_col">
                                                                <AutoCompleteTextBox
                                                                    value={data["UniversityName"]}
                                                                    onChangeSetParentState={this.props.onChangeSetParentState}
                                                                    placeholder={((this.props.submitted || data['readOnly']) && data['UniversityName'] == "")?"":"Institution"}
                                                                    name={"UniversityName" + "?" + i}
                                                                    minLength={3}
                                                                    maxLength={100}
                                                                    autoCompleteUrl={this.props.autoCompleteUrls.cari_api_university_auto_complete_url}
                                                                    required={true}
                                                                    disabled={(this.props.submitted || data['readOnly'])}
                                                                    autoCompleteParams={this.props.autoCompleteParams}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <br/>

                                                    {(!this.props.submitted && !data['readOnly']) ?
                                                        <div>
                                                            <div className="p-grid">
                                                                <div className="p-col-12">
                                                                    {/* <CustomCheckBox
                                                                        name={"customInstitutionCheckboxVal" + "?" + i}
                                                                        onChangeSetParentState={this.props.onChangeSetParentState}
                                                                        checked={data['customInstitutionCheckboxVal']}
                                                                        label={"Check this box if you are unable to find an institution"}
                                                                        disabled={(this.props.submitted || data['readOnly'])}
                                                                    /> */}
                                                                     <CustomButton
                                                                        onClickSetParentState={this.handleAddInstitution}
                                                                        name={"institution_modal" + "?" + i}
                                                                        disabled={this.props.submitted}
                                                                        btnRaised={true}
                                                                        textOnly={true}
                                                                        className={"add_institution_btn"}
                                                                        label={"Add an Institution Not Currently Listed"}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <br/>
                                                        </div>
                                                    : null}

                                                    {/* {(!this.props.submitted && !data['readOnly']) ?
                                                        <div className="p-grid">
                                                            <div className="p-col-12">
                                                                <CustomCheckBox
                                                                    name={"consent" + "?" + i}
                                                                    onChangeSetParentState={this.props.onChangeSetParentState}
                                                                    checked={data['consent']}
                                                                    label={"I consent to SFU contacting this reference"}
                                                                    disabled={!data['enableConsentCheckbox']}
                                                                />
                                                            </div>
                                                        </div>
                                                    : null} */}
    
                                                    <br/> 

                                                </div>
                                            </div>
                                        );
                                    }.bind(this))
                                    : null}

                            </div>

                        </div>
                    </div>

                    <div className="p-grid nav_btn_bar_padding">
                        <div className="p-col-12 scene_element scene_element--fadeinright">
                            <CariAppFormNavBtnBar 
                                page_num={this.getCariFormPageNum()} 
                                match={this.props.match}
                            />
                        </div>
                    </div>                

                </div>

                <CariMainPgFooterView />
            </div>
        );
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CariAppFormViewPg2));